import { createFileRoute, redirect } from '@tanstack/react-router'
import { APP_ROUTES } from '@shared/app-routes'

export const Route = createFileRoute('/dashboard/')({
  beforeLoad: () => {
    throw redirect({ to: APP_ROUTES.dashboard.home })
  },
  component: DashboardIndexRedirect,
})

function DashboardIndexRedirect() {
  return null
}
